import React from 'react';
import { Icon } from 'legacy-packages/ft-cb';
import IconWithDescription from '../index';

import './styles.scss';

export const LABELS = {
  question:
    'This question does not align with the current course and exam. To update this quiz, please remove questions with this icon.',
  assessment:
    'This contains at least one question that no longer aligns with the current course and exam. To update this quiz, please edit and remove questions with this icon.',
};

const RetiredItemIcon = ({ isQuestion = true, width = 'medium' }) => {
  let label = isQuestion ? LABELS.question : LABELS.assessment;

  return (
    <IconWithDescription
      className="retired_indicator"
      width={width}
      trigger={
        <Icon
          name="filled_circle_exclamation"
          className="alert-icon error"
          size="20px"
        />
      }
      popoverAriaLabel="Retired Question"
      tooltipAriaLabel={label}
    >
      <span className="retired_indicator_text">{label}</span>
    </IconWithDescription>
  );
};

RetiredItemIcon.displayName = 'RetiredItemIcon';

export default RetiredItemIcon;
